import { useTranslation } from 'react-i18next';

const ValuesSection = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const values = [
    {
      icon: 'ri-lightbulb-flash-line',
      title: t('values.value1.title'),
      description: t('values.value1.description')
    },
    {
      icon: 'ri-leaf-line',
      title: t('values.value2.title'),
      description: t('values.value2.description')
    },
    {
      icon: 'ri-award-line',
      title: t('values.value3.title'),
      description: t('values.value3.description')
    }
  ];

  return (
    <section className="py-20 bg-primary/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Title */}
        <h2 className="font-almarai font-bold text-4xl md:text-5xl text-gray-900 text-center mb-16">
          {t('values.title')}
        </h2>

        {/* Values Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-12 text-center hover:shadow-lg transition-shadow duration-300"
            >
              {/* Icon */}
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                <i className={`${value.icon} text-5xl text-primary`}></i>
              </div>

              {/* Title */}
              <h3 className="font-almarai font-bold text-3xl text-gray-900 mb-4">
                {value.title}
              </h3>

              {/* Description */}
              <p className="font-tajawal text-base text-gray-600 leading-relaxed">
                {value.description}
              </p>

              {/* Decorative Border */}
              <div className="mt-8 mx-auto w-10 h-1 bg-primary rounded-full"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;